import(/* webpackMode: "eager" */ "/vercel/path0/components/container.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/home/animation-container.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BorderBeam"] */ "/vercel/path0/components/magicui/border-beam.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MagicCard"] */ "/vercel/path0/components/magicui/magic-card.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TextHoverEffect"] */ "/vercel/path0/components/ui/text-hover-effect.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
